export var getComparisonPercentage = function (referenceValue, focusValue) {
    var isPositive = referenceValue > focusValue;
    var oneHundredPercent = 100;
    return isPositive
        ? oneHundredPercent - (focusValue / referenceValue) * oneHundredPercent
        : -((focusValue - referenceValue) / referenceValue) * oneHundredPercent;
};
